module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("layout_tips_menu", [["div",{"class":"link tips"},[["a",{"href":"/tips","class":"text-color-1"},[["i",{"class":"ico icon-au_m_tips"}],["textNode",{"text":" Spoil Me"}]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/layout/home/tipsMenu.tpl
// module id = 1176
// module chunks = 4